import { Component } from '@angular/core';
import { Deal } from '../model';
import { ActivatedRoute } from '@angular/router';
import { BillingServiceService } from '../billing-service.service';
import { ConfirmationService } from 'primeng/api';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { FPAPipe } from '../pipes/fpa.pipe';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { PanelModule } from 'primeng/panel';
import { DropdownModule } from 'primeng/dropdown';
import { ToolbarModule } from 'primeng/toolbar';
import { CardModule } from 'primeng/card';
import { DialogModule } from 'primeng/dialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DealProductsComponent } from '../deal-products/deal-products.component';

@Component({
  selector: 'app-deal-cancelation',
  standalone: true,
  providers: [ConfirmationService],
  imports: [
    DealProductsComponent,
    TranslateModule,
    ReactiveFormsModule, CommonModule,
    ButtonModule, InputTextModule, InputTextModule, TableModule, PanelModule, DropdownModule, ToolbarModule, CardModule, DialogModule, ConfirmDialogModule,
    CurrencyPipe, FPAPipe
  ],
  templateUrl: './deal-cancelation.component.html',
  styleUrl: './deal-cancelation.component.scss'
})
export class DealCancelationComponent {

  deal: Deal | null = null;
  paymentRef: string = "";
  triedToSubmit = false;
  step: string = "one";
  cancellationReasons = [
    { display: "-", key: "" },
    { display: "Price Considered High", key: "Price Considered High" },
    { display: "Resistance to Change / Tech Gap", key: "Resistance to Change / Tech Gap" },
    { display: "Using a Competitor's App", key: "Using a Competitor's App" },
    { display: "Limited # of Reservations", key: "Limited # of Reservations" },
    { display: "Closed / Changes in Ownership", key: "Closed / Changes in Ownership" },
  ];

  protected readonly form = new FormGroup({
    cancellationReason: new FormControl('', [Validators.required]),
  });

  get cancellationReason() { return this.form.get('cancellationReason'); }

  constructor(
    private activatedRoute: ActivatedRoute,
    private billingService: BillingServiceService,
    private confirmationService: ConfirmationService,
    protected translateService: TranslateService) {

    this.activatedRoute.params.subscribe(async params => {
      this.paymentRef = params["ref"];

      this.billingService.getDealForCancel(this.paymentRef).subscribe(deal => {
        this.deal = deal;
      });
    });
  }

  cancel() {
    this.triedToSubmit = true;
    if (this.form.invalid) {
      return;
    }


    this.confirmationService.confirm({
      header: this.translateService.instant("cancel.confirm.title"),
      message: this.translateService.instant("cancel.confirm.message"),
      accept: () => {
        this.submitCancel();
      },
      reject: () => {
      }
    });
  }

  submitCancel() {
    this.billingService.cancel({
      cancelationReason: this.cancellationReason?.getRawValue(),
      cancelId: this.paymentRef
    }).subscribe(() => {
      this.step = "two";
    });
  }
}
